<div class="p-3">
  <div class="modal-header">
    <p class="modal-title">
      <strong>{{ isEditMode ? "Update Document Configuration" : "Create Document Configuration" }}</strong>
    </p>
    <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>
  </div>

  <div class="modal-body p-3">
    <form [formGroup]="createForm" class="d-flex flex-column row">

      <div class="row m-0 pt-2">
        <div class="col-4">
          <label>Country</label>
          <ng-select
            [items]="countries"
            [closeOnSelect]="true"
            [multiple]="false"
            bindLabel="displayText"
            bindValue="id"
            formControlName="country"
            (change)="onCountryChange($event)">
          </ng-select>
        </div>

        <div class="col-4">
          <label>Office Location</label>
          <ng-select
            [items]="officeLocationsInfo"
            [closeOnSelect]="true"
            [multiple]="false"
            bindLabel="displayText"
            bindValue="id"
            formControlName="location">
          </ng-select>
        </div>

        <div class="col-4">
          <label>Legal Entity</label>
          <ng-select
            [items]="officeLegalEntitiesInfo"
            [closeOnSelect]="false"
            [multiple]="!isEditMode"
            bindLabel="displayText"
            bindValue="id"
            formControlName="legalEntity">
            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
              <div class="ng-value" *ngFor="let item of items | slice : 0 : 1">
                <span class="ng-value-label" title={{item.displayText}}> {{ (item.displayText &&
                  item.displayText.length>20)? (item.displayText | slice:0:20)+'...':(item.displayText) }}</span>
                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
              </div>
              <div class="ng-value" *ngIf="items.length > 1">
                <span class="ng-value-label">+{{ items.length - 1 }}</span>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div class="row m-0 pt-2">
        <div class="col-4">
          <label>Document Type</label>
          <ng-select
            [items]="documentTypes"
            [closeOnSelect]="true"
            [multiple]="false"
            bindLabel="documentTypeName"
            bindValue="id"
            formControlName="documentType">
          </ng-select>
          <small class="text-danger mt-1 d-block" *ngIf="isDuplicate">
            This document type is already mapped to the selected legal entity.
          </small>
          <small class="mt-1 d-block" *ngIf="!isEditMode">
            Document type not listed?
            <a href="/configure-governance-newdocument-types">Add new document type</a>
          </small>
        </div>
        <div class="col-4 d-flex align-items-center gap-2 pt-3">
          <input type="checkbox" formControlName="isActive" id="isActiveCheck" />
          <label for="isActiveCheck" class="mb-0">Active</label>
        </div>
      </div>

    </form>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-primary" (click)="onCancel()">Cancel</button>
    <button
      class="btn btn-secondary"
      [disabled]="createForm.invalid || isDuplicate"
      eosDebounce
      (debounceClick)="saveActivity()">
      {{ isEditMode ? "Update" : "Create" }}
    </button>
  </div>
</div>